import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Autocomplete, Divider, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { ChargeService } from "@/service/services/Charge.service";
import { Loading } from "@/components/common/Loading";
import { Props } from "./ModalDepartamentResponsability.type";
import { departmentService } from "@/service/services/Deparment.service";

export const ModalDepartamentResponsability: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, responsability, onListResponsability, clearState, areaSelected } = props;

    const [loading, setLoading] = useState<boolean>(false);

    const [data, setData] = useState({
        id: responsability ? responsability.id : '',
        description: responsability ? responsability.description : '',
    });

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.description) errors.description = "descripcion requerido";
    
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            description: values.description,
            idbusiness_area : areaSelected.id
        }
        setLoading(true);
        if(responsability && actionSelected=='edit'){
            await departmentService.editResponsibilities(formData, responsability.id)
            areaSelected && onListResponsability(areaSelected.id);
            closeModal && closeModal();
        }else{
            await departmentService.createResponsibilities(formData).then((data) => {
                areaSelected && onListResponsability(areaSelected.id);
                closeModal && closeModal();
            })
        }
        setLoading(false);
    }
   
    return(
        <>
        {loading && <Loading/>}

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(responsability && actionSelected=='edit') ? "Editar función" : "Agregar función"}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Descripción:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="description"
                                            variant="standard"
                                            type="text" 
                                            name="description"
                                            fullWidth
                                            value={values.description}
                                            onChange={handleChange}
                                            placeholder="Descripción"
                                            error={errors.description && touched.description ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(responsability && actionSelected=='edit') ? "ACTUALIZAR" : "REGISTRAR"}
                                    cancelText="CANCELAR" 
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}